<template>
  <div>
    <news-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
    >
    </news-header>
    
    <news-center :type="newsType"></news-center>
    <!-- <news-center :type="newsType" :news="newsList" ref="newsRef"></news-center> -->
    <news-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </news-footer>
  </div>
</template>

<script>
import NewsHeader from "@/components/pc/Header";
import NewsCenter from "@/components/pc/NewsCenter";
import NewsTeam from "@/components/pc/NewsTeam";
import NewsFooter from "@/components/pc/Footer";
import axios from "axios";
export default {
  name: "News",
  data() {
    return {
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      actIndex: 7,
      topStyle: "",
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      newsType: [],
      newsList: [],
      teamList: [],
      productType: [],
      bottomNews: [],
    };
  },
  components: {
    NewsHeader,
    NewsCenter,
    NewsTeam,
    NewsFooter,
  },
  mounted() {
    this.Pc_Mobile();
    // this.getPageData();
    this.getHeaderImage();
    this.getNewsType();
    // this.getNewsList();
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_news");
      } else {
        this.$router.push("/news");
      }
    },
    getPageData() {
      this.$http.post("home/index/news", null, (res) => {
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.cp_type;
        this.bottomNews = res.data.b_news;
        this.$nextTick(() => {
          this.$refs.newsRef.imgSwiper();
          this.$refs.teamRef.imgSwiper();
        });
      });
    },
    getNewsType() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/newsType",
        null,
        (res) => {
          if (res.code == 1) {
            // console.log(res.data)
            this.newsType = res.data;
          }
        }
      );
    },
    getNewsList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/news",
        { type_one: 1 },
        (res) => {
          if (res.code == 1) {
            this.newsList = res.data;
          }
        }
      );
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.pc_image + "')";
          }
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/pc/News.vue